import { useEffect, useState } from "react"

export default function ScrollToTopButton() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300)
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  if (!show) return null

  return (
    <button
      type="button"
      className="btn btn-brand-primary opacity-50 position-fixed bottom-0 end-0 m-3 rounded-circle d-inline-flex align-items-center justify-content-center shadow"
      style={{ width: 44, height: 44 }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      title="Back to top"
    >
      ↑
    </button>
  )
}
